import axios from '@/lib/AxApi';

export default
{
    async selectRow(params)
    {
        const response = await axios.get('/Buildings/selectRow', { params });

        return response.data;
    },
    async save(params)
    {
        const response = (params.id != null && params.id !== '')
            ? await axios.post('/Buildings/updateRow', params)
            : await axios.post('/Buildings/insertRow', params);

        return response.data;
    },
    async deleteRow(params)
    {
        const response = await axios.post('/Buildings/deleteRow', params);

        return response.data;
    },
};
